module.exports = __webpack_public_path__ + "static/media/pc.a6abf0ac.svg";